define([
    "jquery",
    "underscore",
    "marionette",
    "swiper",
], function($, _, Marionette, Swiper) {
    return Marionette.View.extend({
        el: '#footer_layout',

        ui:{
            'ukWarningPopup': '#uk_warning_popup'
        },

        initialize: function(){
            this.bindUIElements();

            if(0 < this.ui.ukWarningPopup.length){
                this.ui.ukWarningPopup.modal();
            }

            new Swiper('.swiper-container', {
                spaceBetween:10,
                slidesPerView: 5.5,
                initialSlide: 5,
                noSwiping: true,
                centeredSlides:false,
                autoplayDisableOnInteraction: false,
                loop: true,
                autoHeight: true,
                autoplay: 1500,
                loopAdditionalSlides : 1,
                slidesOffsetBefore:0,
            });
        }
    });
});